import axios from 'axios'
import Tool from "@/util/tool";
import router from '../router'; // 根据你的路由文件路径调整
import { ElMessage } from 'element-plus';

const $http = axios.create({
    baseURL: '',
    timeout: 10000,
    // headers: {'X-Custom-Header': 'foobar'}
    headers: {'Content-Type': 'application/json'}
});

// 请求拦截器：从sessionStorage获取Token并添加到请求头
$http.interceptors.request.use(function (config) {
    // 从sessionStorage中获取Token
    const token = sessionStorage.getItem('token');
    console.log('从sessionStorage获取的token：', token); // 检查是否为null或空
    console.log('Tool.isNotEmpty(token)结果：', Tool.isNotEmpty(token)); // 检查判断结果
    if (Tool.isNotEmpty(token)) {
        config.headers.token = token; // 添加Token到请求头
        console.log('请求头添加token：', token);
    }
    return config;
}, function (error) {
    return Promise.reject(error);
});

$http.interceptors.response.use(function (response) {
    const data = response.data;

    // 假设登录成功后，后端返回包含token的字段（如data.token）
    if (data.token) {
        sessionStorage.setItem('token', data.token); // 存储Token到sessionStorage
        sessionStorage.setItem('userInfo', JSON.stringify(data.userInfo)); // 存储用户信息
        console.log('Token已存储到sessionStorage');
    }

    return data;
}, function (error) {
    // Token过期或无效时清除sessionStorage并跳转到登录页
    if (!error.response || error.response.status === 401) {
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('userInfo'); // 清除用户信息

        // 跳转到登录页
        router.push({
            path: '/', // 根据你的路由配置修改登录页路径
            query: { redirect: router.currentRoute.value.fullPath } // 可选：记录当前路径，登录后跳转回来
        });

        ElMessage.error('登录状态已过期，请重新登录');
    }

    // 其他错误处理
    if (error.response) {
        // 处理其他HTTP状态码错误
        const status = error.response.status;
        console.error(`HTTP错误 ${status}: ${error.response.data.message || '未知错误'}`);
        ElMessage.error(`请求失败: ${status}`);
    } else {
        // 处理网络错误（如请求超时、断网等）
        console.error('网络错误:', error.message);
        ElMessage.error('网络连接失败，请检查网络设置');
    }

    return Promise.reject(error);
});

export default $http;